import { render, staticRenderFns } from "./nbn-ticket-form.vue?vue&type=template&id=0604c700&scoped=true"
import script from "./nbn-ticket-form.vue?vue&type=script&lang=js"
export * from "./nbn-ticket-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604c700",
  null
  
)

export default component.exports